import { Accordion } from '@base-ui/react/accordion'
import React from 'react'
import styled from 'styled-components'

import { Text } from '@utils/Typography'
import { gap } from '@primitives/Layout'
import { ChevronRight } from 'react-feather'
import { flex, typography, space, layout, color, grid } from 'styled-system'

export const NavRoot = styled(Accordion.Root).attrs(props => ({
  gridColumnGap: 1,
  gridRowGap: 3,
  ...props
}))(
  {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr'
  },
  flex,
  grid,
  typography,
  space,
  layout,
  color
)

const StyledAccordionHeader = styled(Accordion.Header)(
  {
    margin: 0,
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: '1 / -1'
  },
  grid
)

const StyledAccordionTrigger = styled(Accordion.Trigger).attrs(props => ({
  gap: 2,
  cursor: 'pointer',
  transition: 'background-color 120ms ease-out',
  p: 0,
  ...props
}))(
  {
    backgroundColor: 'transparent',
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: '1 / -1',
    border: 0,
    alignItems: 'center',
    textAlign: 'left',
    width: '100%',
    textDecoration: 'none',
    transition: 'opacity ease-in-out 0.1s',
    color: 'inherit',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: 'rgba(0, 0, 0, 0.2)',
      textUnderlineOffset: '0.3em'
    }
  },
  flex,
  typography,
  space,
  layout,
  color
)

const StyledAccordionPanel = styled(Accordion.Panel).attrs(props => ({
  gridRowGap: 3,
  pt: 3,
  ...props
}))(
  {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'subgrid',
    gridColumn: '1 / -1'
  },
  grid,
  typography,
  space,
  layout,
  color,
  gap
)

const StyledAccordionItem = styled(Accordion.Item)({
  display: 'grid',
  gridTemplateColumns: 'subgrid',
  gridColumn: '1 / -1',

  '&[data-open]': {
    '.support__section__chevron': {
      transform: 'rotate(90deg)'
    }
  },

  '& [aria-current="page"]': {
    color: '#000'
  },

  '&[data-open]:has([aria-current="page"])': {
    '.support__section__title': {
      fontWeight: 'bold',
      color: '#000'
    }
  }
})

export const NavSection = ({ value, title, children }) => {
  return (
    <StyledAccordionItem value={value}>
      <StyledAccordionHeader>
        <StyledAccordionTrigger>
          <ChevronRight
            width={18}
            height={18}
            color="#585859"
            className="support__section__chevron"
          />
          <Text
            fontSize={1}
            textAlign="left"
            color="#585859"
            className="support__section__title"
          >
            {title}
          </Text>
        </StyledAccordionTrigger>
      </StyledAccordionHeader>
      <StyledAccordionPanel>{children}</StyledAccordionPanel>
    </StyledAccordionItem>
  )
}
